import { rules } from './rules'


const planTeam = Object.freeze({
  title: 'Team',
  id: 'team',
  rule: rules.ruleAdm,
  equipes: {
    qtd: 1, // Conta Principal (dele) 
    integrantes: 20 // Equipe com até 20 integrantes
  },
  crm: true,
  team: true
})

const planSingle = Object.freeze({
  title: 'Single',
  id: 'single',
  rule: rules.ruleAdm,
  equipes: {
    qtd: 2, // Sendo uma conta principal (dele) e o restante (uma) as contas de outras equipes
    integrantes: 0
  },
  crm: true,
  team: false
})

const planUser = Object.freeze({
  title: 'User',
  id: 'use',
  rule: rules.ruleConsulta,
  equipes: {
    qtd: 3, // Até 3 contas 
    integrantes: 0
  },
  crm: true,
  team: false
})

const planFree = Object.freeze({
  title: 'Free',
  id: 'free',
  rule: rules.ruleAdm,
  equipes: {
    qtd: 1,
    integrantes: 2
  },
  crm: true,
  team: true
})

const planAdm = Object.freeze({
  title: 'Adm',
  id: 'adm',
  rule: rules.ruleAdm,
  equipes: {
    qtd: 10, // Conta Principal (dele) + 9 contas de outras equipes
    integrantes: 10
  },
  crm: true,
  team: true
})



const planBroker = Object.freeze({
  title: 'Broker',
  id: 'bro',
  rule: rules.ruleCadastro,
  equipes: {
    qtd: 1,
    integrantes: 0
  },
  crm: false,
  team: true
})

const planAdvanced = Object.freeze({
  title: 'Advanced',
  id: 'adv',
  rule: rules.ruleAdm,
  equipes: {
    qtd: 1,
    integrantes: 2
  },
  crm: true,
  team: true
})

const planBusiness = Object.freeze({
  title: 'Business',
  id: 'bus',
  rule: rules.ruleAdm,
  equipes: {
    qtd: 1,
    integrantes: 2
  },
  crm: true,
  team: true
})



const tpLicenca = Object.freeze({
  TEAM: 'TEAM',
  SINGLE: 'SINGLE',
  USER: 'USER',
  BROKER: 'BROKER',
  ADVANCED: 'ADVANCED',
  BUSINESS: 'BUSINESS',
})

export const plans = Object.freeze({
  // planCRM,
  planUser,
  planSingle,
  planTeam,
  planBroker,
  planAdvanced,
  planBusiness,
  planAdm,
  planFree,
  tpLicenca
})